// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__sNsRx","content":"styles_content__2wVTn","row":"styles_row__2wwEP","footer":"styles_footer__18u0g","phraseLength":"styles_phraseLength__2vBWV"};